module.exports = __webpack_public_path__ + "media/components/src/assets/images/store-image/pmart-3ef6330f8d7db5fb4adf0e11795a0f8e.png";